const makeInitialState = () => {
  return {
    distributor: ""
  };
};

export default makeInitialState;
